/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.nav.config.rpc.NavConfigHomeService
 */
import * as References from './NavConfigHomeService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nav.config.rpc.NavConfigHomeService#getUserHomeKey
 */
export const GET_USER_HOME_KEY_QUERY_FIELD_NAME = 'com_hubspot_nav_config_rpc_NavConfigHomeService_getUserHomeKey';
export const GET_USER_HOME_KEY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_HOME_KEY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getUserHomeKeyRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nav.config.rpc.NavConfigHomeService#resolveHome
 */
export const RESOLVE_HOME_QUERY_FIELD_NAME = 'com_hubspot_nav_config_rpc_NavConfigHomeService_resolveHome';
export const RESOLVE_HOME_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RESOLVE_HOME_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.resolveHomeRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nav.config.rpc.NavConfigHomeService#getHomeOptions
 */
export const GET_HOME_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_nav_config_rpc_NavConfigHomeService_getHomeOptions';
export const GET_HOME_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HOME_OPTIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getHomeOptionsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nav.config.rpc.NavConfigHomeService#setHomeOption
 */
export const SET_HOME_OPTION_MUTATION_FIELD_NAME = 'com_hubspot_nav_config_rpc_NavConfigHomeService_setHomeOption';
export const SET_HOME_OPTION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_HOME_OPTION_MUTATION_FIELD_NAME,
  args: ['homeKey', 'allowCache'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.setHomeOptionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});